export default __webpack_public_path__ + "static/media/pencil-cut.822ec0d9.svg";